import { render, staticRenderFns } from "./ToiletBoxListHeader.vue?vue&type=template&id=4450f13a&scoped=true&lang=pug"
import script from "./ToiletBoxListHeader.vue?vue&type=script&lang=ts"
export * from "./ToiletBoxListHeader.vue?vue&type=script&lang=ts"
import style0 from "./ToiletBoxListHeader.vue?vue&type=style&index=0&id=4450f13a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4450f13a",
  null
  
)

export default component.exports